module.exports = __webpack_public_path__ + "static/media/fiddlehead.5caa3080.jpg";